import { format } from "date-fns";
import { formatDate } from "../../../../utils";
import { value } from "../../../../helpers";

export const PERIODO_PRESETS = [
  { label: "7 dias", dias: 7 },
  { label: "15 dias", dias: 15 },
  { label: "30 dias", dias: 30 },
  { label: "Este mês", mes: true },
];

export function periodoInicial() {
  const hoje = new Date();
  return {
    dataInicio: formatDate.toSend(
      new Date(hoje.getFullYear(), hoje.getMonth(), 1),
    ),
    dataFim: formatDate.toSend(hoje),
  };
}

export const filtrosIniciais = {
  ...periodoInicial(),
  agrupamento: "DIA",
  previsto: true,
  realizado: true,
  considerarSaldoCaixa: false,
  bancosCaixas: [],
  empresas: [],
};

export function intervaloPreset(preset) {
  const dataFim = new Date();
  let dataInicio = new Date();
  if (preset.mes) {
    dataInicio = new Date(dataFim.getFullYear(), dataFim.getMonth(), 1);
  } else {
    dataInicio.setDate(dataInicio.getDate() - preset.dias + 1);
  }
  return {
    dataInicio: formatDate.toSend(dataInicio),
    dataFim: formatDate.toSend(dataFim),
  };
}

export function formatarDataChip(dataStr) {
  if (!dataStr) return "";
  return format(value.date(dataStr), "dd/MM/yyyy");
}

export function modoVisualizacao(filtros) {
  if (filtros.previsto && filtros.realizado) return "previsto_x_realizado";
  return filtros.previsto ? "previsto" : "realizado";
}

export const MODOS = [
  { value: "previsto", label: "Previsto" },
  { value: "realizado", label: "Realizado" },
];

export const MODO_LABELS = {
  previsto_x_realizado: "Previsto x Realizado",
  previsto: "Previsto",
  realizado: "Realizado",
};

export const MODO_DESCRICOES = {
  previsto_x_realizado:
    "Compara movimentações previstas pelo vencimento com as realizadas.",
  previsto: "Considera contas a receber e a pagar pela data de vencimento.",
  realizado: "Considera apenas as movimentações realizadas.",
};

export function dataDiaAnterior(dataStr) {
  if (!dataStr) return "";
  const data = value.date(dataStr);
  if (!data) return "";
  data.setDate(data.getDate() - 1);
  return format(data, "dd/MM/yyyy");
}
